import { Action, Middleware } from '@reduxjs/toolkit';
import { saveCustomizerState } from '../utils/preload.utils';

export const localStorageMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  const result = next(action);

  if ((action as Action).type.startsWith('customizer/')) {
    const state = storeAPI.getState();
    const customizerState = state.customizer;

    try {
      saveCustomizerState(customizerState);
    } catch (e) {
      console.warn('save customizer to localStorage error', e);
    }
  }

  return result;
};
